import React from "react";
import Chart from "react-apexcharts";

export default function SeansGrafik({ seansData, baslik }) {

    const options = {
        chart: {
            id: "seans-chart",
            toolbar: { show: true }
        },
        xaxis: {
            categories: seansData.map(x => x.tarih),
            labels: {
                rotate: -45,
                style: {
                    fontSize: "11px"
                }
            },
            tooltip: {
                enabled: false
            }
        },
        yaxis: {
            title: { text: "Seans Sayısı" },
        },
        stroke: {
            curve: "smooth",
            width: 3
        },
        tooltip: {
            theme: "dark",
        }
    };

    const series = [
        {
            name: "Seans",
            data: seansData.map(x => x.seans)
        }
    ];

    return (
        <div>
            <h5>{baslik}</h5>
            <Chart options={options} series={series} type="line" height={350} />
        </div>
    );
}
